/**
 * View Types that can draw outside the hub — on a public site, and later in an embed (ADR 0020).
 *
 * A View Type joins this list once its canvas runs from rows, the stored View's own settings and what a
 * click should do, with nothing of the hub around it: no GraphContext, no selection, no `?item=`, no
 * interaction mode. Each entry loads its canvas on demand, so a site that never shows a map never
 * downloads one. The hub keeps drawing its own canvas (MapCanvas, with its editing and drawing tools)
 * and reads the same View Settings, so a setting made on a collection's Map View in the hub is what a
 * site's map of that collection does too.
 *
 * Pure — no React here — so a server or a test can ask which types qualify.
 */
export const EMBEDDABLE_VIEWS = Object.freeze({
  map: { label: 'Map', load: () => import('./map/MapView.jsx') },
  // A month of items by the day they start; the hub's CalendarCanvas keeps its week and day layouts.
  calendar: { label: 'Calendar', load: () => import('./calendar/CalendarView.jsx') },
});

/** Can a View of this type draw outside the hub? */
export const isEmbeddableView = (type) => Object.prototype.hasOwnProperty.call(EMBEDDABLE_VIEWS, type);
